export default "__VITE_ASSET__7fcbde59__"